import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import x from './userRights'
const Option = Select.Option

@Form.create()
class RegulariseAttendence extends React.Component {
    state = {
        visible: true,
        file: '',
        loading: false,
        arr: [],
        inputTypes: {
            fields: [
                {
                    label: 'Attendance Date',
                    key: 'attendanceDate',
                    type: 'date',
                    required: true,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'Start Time',
                    key: 'loginAt',
                    type: 'time',
                    format: 'HH:MM:SS',
                    required: true,
                },
                {
                    label: 'Vision Start Time',
                    key: 'logoutAt',
                    type: 'time',
                    required: true,
                },
                {
                    label: 'Reason',
                    key: 'updateReason',
                    type: 'text',
                    required: true,
                }
            ]
        }
    }


    setFormValue = () => {
        const { form, oldAttendence } = this.props;
        setTimeout(() => {
            form.setFieldsValue({
                attendanceDate: moment(oldAttendence._id.attendanceDate)
            })
        }, 500)
    }


    componentDidMount() {
        this.setFormValue()
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, courseId, oldAttendence } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values.userId = oldAttendence._id.userId
                this.setState({ loading: true });
                let response = await Request.requestAttendenceRegularisation(values)
                this.setState({ loading: false });
                if (!response.error) {
                    this.onClose();
                    notification.success({
                        message: response.message
                    })
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }
        })
    }

    render() {

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible, inputTypes } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Request Regularisation
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegulariseAttendence)
